module.exports = __webpack_public_path__ + "img/ic_send_nor.bcea855c.svg";